import React, { useState } from 'react';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { TextField, InputAdornment, IconButton } from '@mui/material';

const PasswordInput: React.FC<any> = ({
  label = 'Senha',
  value,
  onChange,
  ...props
}) => {
  const [mostrarSenha, setMostrarSenha] = useState(false);

  const handleClickMostrarSenha = () => {
    setMostrarSenha(!mostrarSenha);
  };

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };

  return (
    <TextField
      label={label}
      type={mostrarSenha ? 'text' : 'password'}
      value={value}
      onChange={onChange}
      error={!!props.error}
      helperText={props.helperText}
      variant="outlined"
      sx={{
        '& input::-ms-reveal, & input::-ms-clear': {
          display: 'none',
        },
        ...props.sx,
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="alternar visibilidade da senha"
              onClick={handleClickMostrarSenha}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {mostrarSenha ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
        ...props.InputProps,
      }}
      {...props}
    />
  );
};

export default PasswordInput;
